export default [
  {
    path: '/hs-code',
    name: 'hs-code',
    component: () => import('@/views/hs-code/HSCode.vue'),
    meta: {
      title: 'HS Code',
      requiresAuth: true,
      pageTitle: ' HS Code',
      action: 'browes',
      breadcrumb: [
        {
          text: 'HS Code',
          active: true,
        },
      ],
    },
  },
  {
    path: '/add-hs-code',
    name: 'add-hs-code',
    component: () => import('@/views/hs-code/AddHSCode.vue'),
    meta: {
      title: 'Add HS Code',
      requiresAuth: true,
      pageTitle: 'Add HS Code',
      action: 'browes',
      breadcrumb: [
        {
          text: 'Add HS Code',
          active: true,
        },
      ],
    },
  },
]
